import {Component, OnInit} from '@angular/core';
import {InboxApiService} from '@features/inbox/services/inbox-api.service';
import {catchError, concatMap} from 'rxjs/operators';
import {GetMailByIdFailedAction, GetMailByIdSuccessAction} from '@features/inbox/store/actions/inbox.actions';
import {MarkMailAsReadCommand} from '@features/inbox/commands/inbox.command';
import {Observable, of} from 'rxjs';

@Component({
    standalone: false,
    selector: 'app-mailbox-list',
  templateUrl: './mailbox-list.component.html',
  styleUrls: ['./mailbox-list.component.css']
})
export class MailboxListComponent implements OnInit {

  public mailList: any[] = [];

  constructor(
    private inboxApiService: InboxApiService
  ) {
  }

  ngOnInit(): void {
    this.inboxApiService.getAllMailsByLabel('inbox').subscribe((data: any) => {
      this.mailList = [...data.items];
    });
  }

}
